import { VIEW_ALL_FILTER, ALL_CONTACTS_FILTER } from './constants';

// Generates options to be used on the filter dropdowns, based on a list of items

export const getContactOptions = (items, loggedAccountName) => {
  let optionsByContactName = {};
  let showLoggedAccountOption = false;

  for (const item of items) {
    if (item.contactName !== loggedAccountName) {
      optionsByContactName[item.contactName] = {
        id: item.contactName,
        text: item.contactName,
      };
    } else {
      showLoggedAccountOption = true;
    }
  }

  return [
    { id: ALL_CONTACTS_FILTER, text: 'All Contacts' },
    ...(showLoggedAccountOption
      ? [{ id: loggedAccountName, text: loggedAccountName }]
      : []),
    ...Object.values(optionsByContactName),
  ];
};

export const getStatusOptions = (items) => {
  const optionsByStatus = {};

  for (const item of items) {
    optionsByStatus[item.status] = {
      id: item.status,
      text: item.status,
    };
  }
  return [
    { id: VIEW_ALL_FILTER, text: 'View all' },
    ...Object.values(optionsByStatus),
  ];
};
